import React from 'react';

const PriceTagIcon: React.FC = () => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.08451 2.23779L17.3337 3.41696L18.512 11.667L10.852 19.327C10.6957 19.4832 10.4838 19.5709 10.2628 19.5709C10.0419 19.5709 9.82995 19.4832 9.67368 19.327L1.42368 11.077C1.26745 10.9207 1.17969 10.7088 1.17969 10.4878C1.17969 10.2668 1.26745 10.0549 1.42368 9.89863L9.08451 2.23779ZM9.67368 4.00613L3.19118 10.4878L10.2628 17.5586L16.7445 11.077L15.8612 4.88946L9.67368 4.00613ZM11.4403 9.30946C11.1277 8.99673 10.9521 8.57261 10.9522 8.13041C10.9522 7.91146 10.9954 7.69466 11.0792 7.49239C11.1631 7.29012 11.2859 7.10634 11.4408 6.95154C11.5956 6.79675 11.7794 6.67397 11.9817 6.59021C12.184 6.50646 12.4009 6.46337 12.6198 6.46341C13.062 6.46349 13.4861 6.63923 13.7987 6.95196C14.1113 7.26469 14.2869 7.68881 14.2868 8.131C14.2867 8.5732 14.111 8.99725 13.7983 9.30988C13.4855 9.6225 13.0614 9.79809 12.6192 9.79801C12.177 9.79793 11.753 9.62219 11.4403 9.30946Z'
        fill='#C7C6CF'
      />
    </svg>
  );
};

export default PriceTagIcon;
